@if (showTitleHeader) {
  <div class="flex-child-one" *ngrxLet="isMobile$ as isMobile">
    @if (!isMobile && showBackButton) {
      <button
        mat-icon-button
        class="back-button"
        (click)="backButtonClick.emit()"
        >
        <fa-icon [icon]="backButtonIcon"></fa-icon>
      </button>
    }
    @if (isMobile && showBackButton) {
      <button
        mat-icon-button
        class="close-button"
        (click)="backButtonClick.emit()"
        >
        <fa-icon [icon]="backButtonIcon"></fa-icon>
      </button>
    }
    <div class="title-wrapper">
      <div class="title">{{ title }}</div>
      @if (subTitle && (!isMobile || showSubTitleInMobile)) {
        <div
          class="sub-title"
          >
          {{ subTitle }}
        </div>
      }
    </div>
    @if (isMobile && showSecondaryButton) {
      <button
        mat-icon-button
        class="secondary-button"
        [class.is-loader]="secondaryButtonLoading"
        (click)="secondaryButtonClick.emit()"
        >
        <fa-icon [icon]="secondaryButtonIcon"></fa-icon>
      </button>
    }
    <loading-spinner
      class="secondary-button-loader"
      [isLoading]="secondaryButtonLoading"
    ></loading-spinner>
  </div>
  <ng-content select="[infoMessage]"></ng-content>
}
<ng-content></ng-content>
